import { TuteeEdit } from "./TuteeEdit";
import { TuteeList } from "./TuteeList";
import { TuteeShow } from "./TuteeShow";

export default {
  list: TuteeList,
  edit: TuteeEdit,
  show: TuteeShow,
};
